export enum DeviceCodeAuthorizationStep {
    WaitingToStart = 'WaitingToStart',
    StartDeviceAuthorization = 'StartDeviceAuthorization',
    DeviceCodeAuthorization = 'DeviceCodeAuthorization',
}
